export const ENVIRONMENT_CONSTANTS = {
	APP_ENVIRONMENT: '@@APPENV@@',
	APP_REGION: '@@APPREGION@@',
	PROD: 'production',
	DEV: 'development'
};
